/** angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** end angular */

/** models */
import { BydModel } from '@sixense/byd-core-service';
/** end models */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/** functions */
import { DsLinearFormInstanceLink } from '../models/ds-linear-form-instance-link';
import { DsLinearFormInstanceLinkInterface } from '../interfaces/ds-linear-form-instance-link.interface';
/** end functions */

@Injectable({
  providedIn: 'root',
})
export class DsLinearFormInstanceLinksService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Gets the lane links.
   *
   * @param projectId The current project id
   * @param instanceId The form instance id
   * @returns Observable<DsLinearFormInstanceLink>
   */
  public getLaneLinks(projectId: number, instanceId: number): Observable<BydModel<DsLinearFormInstanceLink>> {
    this.path = `/v1/dslinear/projects/${projectId}/instances/${instanceId}/lanes`;
    return this.getModels<DsLinearFormInstanceLink>();
  }

  /**
   * Gets the work links.
   *
   * @param projectId The current project id
   * @param instanceId The form instance id
   * @returns Observable<DsLinearFormInstanceLink>
   */
  public getWorkLinks(projectId: number, instanceId: number): Observable<BydModel<DsLinearFormInstanceLink>> {
    this.path = `/v1/dslinear/projects/${projectId}/instances/${instanceId}/works`;
    return this.getModels<DsLinearFormInstanceLink>();
  }

  /**
   * Create DsLinearFormInstanceLink instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsLinearFormInstanceLink` instance.
   */
  public createNewInstance(jsonObject: DsLinearFormInstanceLinkInterface): DsLinearFormInstanceLink {
    return new DsLinearFormInstanceLink(jsonObject);
  }
}
